// taken from angular.js

import { isObject } from 'lodash';

const NUMBER_TYPE_DECIMAL_SEP = '.';

const DECIMAL_SEP = ',';
const GROUP_SEP = ' ';

const pattern = {
  gSize: 3,
  lgSize: 3,
  maxFrac: 3,
  minFrac: 0,
  minInt: 1,
  negPre: '-',
  negSuf: '',
  posPre: '',
  posSuf: '',
};

export default (number, fractionSize = 2, type) => {
  if (isObject(number)) return '-';
  if (number == null) return '-';

  var isNegative = number < 0;
  number = Math.abs(number);

  var isInfinity = number === Infinity;
  if (!isInfinity && !isFinite(number)) return '';

  let suffix = '';

  if (type !== 'plain') {
    if (number >= 1000000000) {
      number /= 1000000000;
      suffix = ' mrd.';
    } else if (number >= 1000000) {
      number /= 1000000;
      suffix = ' mill.';
    }
  }

  var numStr = number + '';
  var formatedText = '';
  var hasExponent = false;
  var parts = [];

  if (isInfinity) formatedText = '\u221e';

  if (!isInfinity && numStr.indexOf('e') !== -1) {
    var match = numStr.match(/([\d.]+)e(-?)(\d+)/);
    if (match && match[2] === '-' && match[3] > fractionSize + 1) {
      number = 0;
    } else {
      formatedText = numStr;
      hasExponent = true;
    }
  }

  if (!isInfinity && !hasExponent) {
    // safely round numbers in JS without hitting imprecisions
    // of floating-point arithmetics
    number = +(
      Math.round(+(number.toString() + 'e' + fractionSize)).toString() +
      'e' +
      -fractionSize
    );

    var fraction = ('' + number).split(NUMBER_TYPE_DECIMAL_SEP);
    var whole = fraction[0];
    fraction = fraction[1] || '';

    var i,
      pos = 0;
    var lgroup = pattern.lgSize;
    var group = pattern.gSize;

    if (whole.length >= lgroup + group) {
      pos = whole.length - lgroup;
      for (i = 0; i < pos; i++) {
        if ((pos - i) % group === 0 && i !== 0) {
          formatedText += GROUP_SEP;
        }
        formatedText += whole.charAt(i);
      }
    }

    for (i = pos; i < whole.length; i++) {
      if ((whole.length - i) % lgroup === 0 && i !== 0) {
        formatedText += GROUP_SEP;
      }
      formatedText += whole.charAt(i);
    }

    // format fraction part.
    while (fraction.length < fractionSize) {
      fraction += '0';
    }

    if (fractionSize && fractionSize !== '0') {
      formatedText += DECIMAL_SEP + fraction.substr(0, fractionSize);
    }
  } else {
    if (fractionSize > 0 && number < 1) {
      formatedText = number.toFixed(fractionSize);
      number = parseFloat(formatedText);
    }
  }

  if (number === 0) {
    isNegative = false;
  }

  parts.push(
    isNegative ? pattern.negPre : pattern.posPre,
    formatedText,
    isNegative ? pattern.negSuf : pattern.posSuf,
  );

  parts.push(suffix);

  return parts.join('');
};
